module.exports = __webpack_public_path__ + "static/media/shrimp.4ba1413a.png";